import {storeInstance} from '@aofl/store/dist/legacy';
import {sdoNs} from '@modules/constants-enumerate';
import {deepAssign} from '@aofl/object-utils';

const DEFAULT_LANGS = [
  {
    label: 'English',
    code: 'en-US',
    enabled: true,
  },
  {
    label: 'Español',
    code: 'es-US',
    enabled: true,
  },
  {
    label: '日本語',
    code: 'ja-JP',
    enabled: true,
  },
  {
    label: '简体中文',
    code: 'zh-CN',
    enabled: true,
  },
  {
    label: '繁体中文',
    code: 'zh-TW',
    enabled: true,
  },
];

const sdo = {
  namespace: sdoNs.LOCALE_DD,
  mutations: {
    init(payload) {
      return Object.assign({
        supportedLangs: DEFAULT_LANGS,
        filters: [],
        selected: {},
        geoipCountry: 'US',
        ipInfo: {},
      }, payload);
    },
  },
  decorators: [
    (nextState) => { // $supportedLanguages
      const currState = storeInstance.getState();
      const subState = currState[sdoNs.LOCALE_DD];
      const nextSubState = nextState[sdoNs.LOCALE_DD];
      if (
        typeof nextSubState.$supportedLanguages === 'undefined' ||
        subState.filters !== nextSubState.filters
      ) {
        const $supportedLanguages = [];
        if (nextSubState.filters?.length) {
          DEFAULT_LANGS.map((lang) => {
            if (
              nextSubState.filters.indexOf(lang.code) !== -1
            ) {
              $supportedLanguages.push(
                {
                  ...lang,
                  enabled: true
                }
              );
            }
          });
        } else {
          DEFAULT_LANGS.map((lang) => {
            if (lang.enabled) {
              $supportedLanguages.push(lang);
            }
          });
        }
        nextState = deepAssign(nextState, sdoNs.LOCALE_DD, {$supportedLanguages});
      }
      return nextState;
    },
  ]
};

storeInstance.addState(sdo);
